var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgLinkedinIcon = function SvgLinkedinIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 23 23",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0073B1",
    d: "M22.994 23v-.001H23v-8.435c0-4.127-.888-7.306-5.712-7.306-2.32 0-3.876 1.273-4.511 2.48h-.067V7.643H8.136v15.355h4.763v-7.604c0-2.001.379-3.937 2.858-3.937 2.443 0 2.48 2.284 2.48 4.066V23zM.38 7.645h4.768V23H.38zM2.762 0A2.763 2.763 0 0 0 0 2.762C0 4.287 1.237 5.55 2.762 5.55s2.762-1.263 2.762-2.788A2.764 2.764 0 0 0 2.762 0"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLinkedinIcon);
export default ForwardRef;